import { createFileRoute } from '@tanstack/react-router';
import {
  OAuthCallbackFailed,
  completeOAuthCallback,
  oauthCallbackSearch,
  requireOAuthCallbackAccess,
} from '@/components/integrations-hub/oauth-callback';

// Attio redirects here with ?code&state (the redirect URI registered at build.attio.com).
export const Route = createFileRoute(
  '/_auth/_side-layout/integrations/attio/callback',
)({
  validateSearch: oauthCallbackSearch,
  beforeLoad: ({ context }) => requireOAuthCallbackAccess(context),
  loaderDeps: ({ search }) => search,
  loader: ({ deps, context }) =>
    completeOAuthCallback('attio', deps, context.queryClient),
  component: AttioCallbackPage,
});

function AttioCallbackPage() {
  const { failedReason } = Route.useLoaderData();
  return (
    <OAuthCallbackFailed integrationId="attio" failedReason={failedReason} />
  );
}
